import React from 'react';
import PropTypes from 'prop-types';
const moment = require('moment-timezone');
import { withRouter } from 'react-router-dom';

const Strings = require('../../../../app/shared/Strings');
const TimeUtil = require('../../../../app/shared/TimeUtil');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
import SortableTable2 from '../table/SortableTable2';
import ConfirmModal from '../modal/ConfirmModal';
import WithActivityData from '../DataHOCs/WithActivityData';
import WithChannelData from '../DataHOCs/WithChannelData';
import WithProjectData from '../DataHOCs/WithProjectData';
import WithActivitySavesPoll from '../DataHOCs/WithActivitySavesPoll';
import Tooltip from '../common/Tooltip';

const propTypes = {
    history: PropTypes.object.isRequired,
    activitySaves: PropTypes.array.isRequired,
    currentActivityVersion: PropTypes.string.isRequired,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectStoreState: PropTypes.shape({ project: PropTypes.object.isRequired }).isRequired,
    channelStoreState: PropTypes.shape({ channel: PropTypes.object.isRequired }).isRequired,
    viewValidationForVesionFunc: PropTypes.func,
};
const defaultProps = {
    viewValidationForVesionFunc: null,
};

class ActivitySavesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // initUsersBatchLoaded: false,
            initUsersBatchLoaded: true,
            loadUserActionId: false,
            oldVersion: null,
            modalState: {
                editOldVersion: false
            }
        };

        this.selectSaveVersion = this.selectSaveVersion.bind(this);
        this.toggleEditOldVersionModal = this.toggleEditOldVersionModal.bind(this);
        this.editOldVersion = this.editOldVersion.bind(this);
    }

    selectSaveVersion(actId) {
        const save = this.props.activitySaves.find(save => save.id === actId);
        if (save && save.doc_exists) {
            if (this.props.currentActivityVersion !== save.version) {
                this.setState({ oldVersion: save.version }, () => {
                    this.toggleEditOldVersionModal(true);
                });
            }
        }
    }

    toggleEditOldVersionModal(showBool) {
        this.setState({ modalState: { ...this.state.modalState, editOldVersion: showBool } });
    }

    editOldVersion() {
        this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/activity/${this.props.activityId}/edit/${this.state.oldVersion}`);
    }

    render() {
        const self = this;
        const canEditActivity = PermissionsUtil.canEditActivity(
            this.props.channelStoreState.channel.user_permissions,
            this.props.projectStoreState.project.user_permissions
        );
        const guessedTimezone = moment.tz.guess();

        return (
            <div>
                <SortableTable2
                    classNameTable="margin-bottom-15 font-size-md activitySavesTable"
                    hideSearch
                    showTotal={false}
                    uniqueRowKey="id"
                    rows={this.props.activitySaves}
                    dateFormat="YY-MM-DD HH:mm zz"
                    defaultSort={{ key:'saved_at', type:'date', asc: false }}
                    topGroupHeader= {[
                        {
                            displayName: '',
                            colSpan: '1',
                            width: '14%',
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_SAVE,
                            colSpan: '3',
                            width: '43%',
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_PUBLISH,
                            colSpan: '3',
                            width: '43%',
                        },
                    ]}
                    columns={[
                        {
                            displayName: Strings['en'].activity.saves.THEAD_VERSION,
                            key: 'version',
                            type: 'string',
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_SAVE_USER,
                            key: 'user_id',
                            type: 'number',
                            sortable: false,
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_SAVE_DATE,
                            key: 'saved_at',
                            type: 'date',
                            
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_SAVE_MSG,
                            key: 'message',
                            type: 'string',
                            sortable: false,
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_PUB_USER,
                            key: 'published_by',
                            type: 'number',
                            sortable: false,
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_PUB_DATE,
                            key: 'published_on',
                            type: 'date'
                        },
                        {
                            displayName: Strings['en'].activity.saves.THEAD_PUB_MSG,
                            key: 'publish_message',
                            type: 'string',
                            sortable: false,
                        },
                    ]}
                    displayColumnCallbacks={{
                        'version': (version, uniqueRowId) => {
                            return (
                                <span>
                                    {(canEditActivity) ?
                                        <button
                                            className="bare-text-button no-button-style"
                                            onClick={self.selectSaveVersion.bind(null, uniqueRowId)}
                                        >
                                            {version}
                                        </button>
                                        :
                                        version
                                    }
                                    {(version === self.props.currentActivityVersion) &&
                                        <Tooltip
                                            id="current-version-tooltip"
                                            className="margin-left-sm mzl-cs-special-button"
                                        >
                                            {Strings['en'].activity.saves.TABLE_CURRENT_VERSION}
                                        </Tooltip>
                                    }
                                    {(!!self.props.viewValidationForVesionFunc) &&
                                        <button
                                            className="bare-text-button glyph button-following"
                                            title={Strings['en'].activity.saves.TABLE_VALIDATION_RPT}
                                            aria-label={Strings['en'].activity.saves.TABLE_VALIDATION_RPT}
                                            onClick={self.props.viewValidationForVesionFunc.bind(null, version)}
                                        >
                                            <span className="fa fa-sticky-note-o" aria-hidden="true"/>
                                        </button>
                                    }
                                </span>
                            );
                        },
                        'message': (message, uniqueRowId) => {
                            if (!message) return null;
                            return (
                                <Tooltip
                                    id={`save-msg-${uniqueRowId}`}
                                    className="mzl-cs-special-button"
                                    placement="top"
                                    icon="fa-info-circle"
                                >
                                        {message}
                                </Tooltip>
                            );
                        },
                    }}
                    displayColumnCallbacksRow={{
                        'user_id': (row, uniqueRowId) => {
                            if (!row.saved_by_first_name && !row.saved_by_last_name) return null;
                            return <span>{row.saved_by_first_name} {row.saved_by_last_name}</span>
                        },
                        'published_by': (row, uniqueRowId) => {
                            if (!row.published_by_first_name && !row.published_by_last_name) return null;
                            return <span>{row.published_by_first_name} {row.published_by_last_name}</span>
                        },
                        'publish_message': (row, uniqueRowId) => {
                            return (
                                <PublishMessageTooltip
                                    id={uniqueRowId}
                                    timezone={guessedTimezone}
                                    saveData={row}
                                />
                            );
                        },
                    }}
                />
                {this.state.modalState.editOldVersion &&
                    <ConfirmModal
                        show
                        text={`Are you sure you wish to edit the previous version ${this.state.oldVersion}? Saving will bypass more recent changes.`}
                        closeHandler={this.toggleEditOldVersionModal.bind(this, false)}
                        confirmHandler={this.editOldVersion}
                    />
                }
            </div>
        );
    }
}

ActivitySavesTable.propTypes = propTypes;
ActivitySavesTable.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithActivityData(WithChannelData(WithProjectData(WithActivitySavesPoll(ActivitySavesTable)))));

export default WrappedComponent;

export function PublishMessageTooltip(props) {
    if (props.saveData.unpublished) {
        return (
            <Tooltip
                id={`unpub-msg-${props.id}`}
                placement="top"
                icon="fa-remove"
            >
                <div className="margin-bottom-sm">
                    {Strings['en'].activity.IS_UNPUBLISHED}
                </div>
                <div className="margin-bottom-sm">
                    {Strings['en'].activity.UNPUBLISHED_ON}: {TimeUtil.convertToTimeZone(props.saveData.unpublished_on, props.timezone).format("YY-MM-DD HH:mm zz")}
                </div>
                <div className="margin-bottom-sm">
                    {Strings['en'].activity.UNPUBLISHED_BY}: <span>{props.saveData.unpublished_by_first_name} {props.saveData.unpublished_by_last_name}</span>
                </div>
                <div>
                    {Strings['en'].activity.ORIG_PUBLISH_MSG}: {(!!props.saveData.publish_message) ?
                        <span>"{props.saveData.publish_message}"</span>
                        :
                        <span className="font-style-italic">{Strings['en'].common.NONE}</span>
                    }
                </div>
            </Tooltip>
        );
    }
    else if (props.saveData.published) {
        return (
            <Tooltip
                id={`pub-msg-${props.id}`}
                placement="top"
                icon="fa-info-circle"
            >
                <div>
                    {Strings['en'].activity.PUBLISH_MSG}: {(!!props.saveData.publish_message) ?
                        <span>{props.saveData.publish_message}</span>
                        :
                        <span className="font-style-italic">{Strings['en'].common.NONE}</span>
                    }
                </div>
                <div>
                    {Strings['en'].activity.publish.UPDATE_INACTIVE_ASSN}: {props.saveData.update_inactive ? Strings['en'].common.YES : Strings['en'].common.NO}
                </div>
                <div>
                    {Strings['en'].activity.publish.UPDATE_ACTIVE_ASSN}: {props.saveData.update_active ? Strings['en'].common.YES : Strings['en'].common.NO}
                </div>
            </Tooltip>
        );
    }
    else {
        return null;
    }
}

PublishMessageTooltip.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    timezone: PropTypes.string.isRequired,
    saveData: PropTypes.shape({
        unpublished: PropTypes.bool.isRequired,
        unpublished_on: PropTypes.string,
        unpublished_by_first_name: PropTypes.string,
        unpublished_by_last_name: PropTypes.string,
        publish_message: PropTypes.string,

    }).isRequired,
};
PublishMessageTooltip.defaultProps = {};